import { render, staticRenderFns } from "./ProductListUpdated.vue?vue&type=template&id=65619e63&scoped=true"
import script from "./ProductListUpdated.vue?vue&type=script&lang=js"
export * from "./ProductListUpdated.vue?vue&type=script&lang=js"
import style0 from "./ProductListUpdated.vue?vue&type=style&index=0&id=65619e63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65619e63",
  null
  
)

export default component.exports